import { useTreeCourses } from '@/data/context/TreeCoursesContext';
import { ModuleTabs } from '@/pages/course-line/ModuleWorkspace';
import { mountKey } from '@/utils/courses';
import { ROUTES, withTab } from '@/utils/routes';

export default function usePedagogicalContentTo(courseLineId: number) {
  const { tree } = useTreeCourses();

  const courseLineNode =
    tree?.current.nodes[mountKey({ type: 'courseLine', id: courseLineId })];
  const firstChild = courseLineNode?.children.values().next().value;
  const firstModuleId = firstChild ? Number(firstChild.data.realId) : undefined;

  if (!firstModuleId) return undefined;

  return {
    to: withTab(
      ROUTES.ADMIN.COURSE_LINES.MODULE(courseLineId, firstModuleId),
      ModuleTabs.PED_CONTENT,
    ),
  };
}
